import { MutationTree } from 'vuex';
import { State } from './state';
import {
    SET_FUNCTIONALITY_LIST,
    SET_REGISTER_FORM_VISIBILITY,
    SET_SELECTED_FUNCTIONALITY,
    ADD_FUNCTIONALITY_TO_LIST,
    SET_SELECTED_FUNCTIONALITY_SYSTEM,
    SET_GROUPED_FUNCTIONALITY_LIST,
} from './types';
import { IFunctionality } from '../models';
import { ISystem } from '@/modules/system/models';


export const mutations: MutationTree<State> = {
    [SET_FUNCTIONALITY_LIST](state: State, payload: IFunctionality[]) {
        state.functionalities = payload;
    },
    [SET_REGISTER_FORM_VISIBILITY](state: State, payload: boolean) {
        state.showRegisterForm = payload;
    },
    [SET_SELECTED_FUNCTIONALITY](state: State, payload: IFunctionality) {
        state.functionalitySelected = payload;
    },
    [ADD_FUNCTIONALITY_TO_LIST](state: State, payload: IFunctionality) {
        state.functionalities.push(payload);
    },
    [SET_SELECTED_FUNCTIONALITY_SYSTEM](state: State, payload: ISystem) {
        state.functionalitySelected.system = payload;
    },
    [SET_GROUPED_FUNCTIONALITY_LIST](state: State, payload: any[]) {
        state.groupedFunctionalities = payload;
    },
};
